import { Component, Input, OnInit } from "@angular/core";
import { Observable, take } from "rxjs";
import { BaseListModel } from "@webapp/core/abstracts/models/base-list.model";
import { WhiteboardsFacade } from "@webapp/whiteboards/services/whiteboards-facade.service";
import { RequestPaging } from "@webapp/core/abstracts/models/request.paging";
import { StorageService } from "@webapp/core/storage/services/storage.service";
import { HttpActions } from "@webapp/core/abstracts/enums/http-actions.enum";
import { Whiteboard } from "@webapp/whiteboards/models/whiteboard.models";

@Component({
  selector: "gh-example-whiteboards-component",
  templateUrl: "./example-whiteboards.component.html",
})
export class ExampleWhiteboardsComponent implements OnInit {
  @Input()
  public test!: number;

  public isGetAllLoading$ = this.whiteboardsFacade.getState().isLoading$(HttpActions.getAll);
  public isGetLoading$ = this.whiteboardsFacade.getState().isLoading$(HttpActions.get);

  public whiteboard$!: Observable<Whiteboard>;

  public whiteboards$: Observable<BaseListModel<Whiteboard>>;

  public constructor(private whiteboardsFacade: WhiteboardsFacade, private storageService: StorageService) {}

  public ngOnInit(): void {
    const userId = this.storageService.get<string>("userId");

    this.loadWhiteboardList(userId);
    // the get by ID is not supported by this endpoint
    this.whiteboard$ = this.whiteboardsFacade.get$("615ea111f27aa96a5017b6e8");

    setTimeout(() => {
      this.whiteboardsFacade
        .post$({ ...new Whiteboard(), name: "Test New Whiteboard" })
        .pipe(take(1))
        .subscribe(() => {
          this.loadWhiteboardList(userId);
        });
    }, 3000);
  }

  public loadWhiteboardList(userId: string): void {
    // this should fetch the created by you whiteboards
    this.whiteboards$ = this.whiteboardsFacade.getAll$({
      ...new RequestPaging(),
      filter: { createdById: { $in: [userId] } },
      fields: ["id", "name", "tags", "access", "tag", "currentUserAllowedActions"],
      limit: 30,
      skip: 0,
    });
  }
}
